import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04a3c6ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "language-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLanguage('fr')))
    }, " 🇫🇷 ", 512), [
      [_vShow, this.store.state.language === 'en']
    ]),
    _withDirectives(_createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLanguage('en')))
    }, " 🇬🇧 ", 512), [
      [_vShow, this.store.state.language === 'fr']
    ])
  ]))
}